import React, { Component } from "react";
import { Dropdown } from "react-bootstrap";
import { Link } from "react-router-dom";

class KeywordSearchField extends Component {
	state = {
		isOpen: false,
		search: ""
	};

	componentDidUpdate(prevProps) {
		const { reset } = this.props;
		if (reset !== prevProps.reset) {
			this.setState({ search: "" });
		}
	}

	toggleDropDown = (bool) => {
		this.setState({
			isOpen: bool
		});
	};

	searchTimeout = null;
	onSearch = ({ target }) => {
		const { searchField, searchAction } = this.props;
		const value = target.value;
		this.setState({
			search: value
		});
		clearTimeout(this.searchTimeout);
		this.searchTimeout = setTimeout(() => {
			const queryParams = value && value.length > 2 ? `${searchField}=${value}` : `${searchField}`;
			searchAction(queryParams);
		}, 500);
	};

	handleKeyDown = (e) => {
		if (e.nativeEvent.key === "Enter") {
			this.onSearch(e);
		}
	}

	render() {
		const { isOpen, search } = this.state;
		const { searchResults, placeholder = "Search Keywords", itemLink, name = "searchKeyword", className = "" } = this.props;

		const InputField = (
			<div className={`form-group search-field m-0 ${className}`}>
				<input
					className="form-control"
					type="text"
					onFocus={() => this.toggleDropDown(true)}
					onBlur={() => setTimeout(() => this.toggleDropDown(false), 200)}
					onChange={this.onSearch}
					onKeyPress={this.handleKeyDown}
					value={search}
					placeholder={placeholder}
					name={name}
					autoComplete="off"
					autoCorrect="off"
				/>
				<i className="icon icon-search" />
			</div>
		);
		return searchResults ? (
			<Dropdown drop="down" className="mb-0 mr-2 search-wrap" show={isOpen}>
				{InputField}
				<Dropdown.Menu className="search-results">
					<div className="search-results-nav">
						{searchResults && searchResults.length ? (
							searchResults.map((item) => {
								const to = itemLink.replace(/:id/, item.id);
								return (
									<Link key={item.id} to={to} className="search-results-item">
										{item.name}
									</Link>
								);
							})
						) : (
								<li className="search-results-placeholder">Enter your keyword!</li>
							)}
					</div>
				</Dropdown.Menu>
			</Dropdown>
		) : (
				<div className="search-wrap">{InputField}</div>
			);
	}
}

export default KeywordSearchField;
